import Vue from "vue";
import VueRouter from "vue-router";
//import Address from "../views/Address.vue";
import Dates from "../views/Dates.vue";
import Distance from "../views/Distance.vue";
import Objects from "../views/Objects.vue";
import PersonalData from "../views/PersonalData.vue";
import Service from "../views/Service.vue";
import Terms from "../views/Terms.vue";
// import Type from "../views/Type.vue";
// import Moving from "../views/Moving.vue";
// import Protection from "../views/Protection.vue";
import Supplier from "../views/Supplier.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Distance",
    component: Distance,
    type: "both"
  },
  // {
  //   path: "/type",
  //   name: "Type",
  //   component: Type,
  //   type: "both"
  // },
  {
    path: "/leverancier",
    name: "Supplier",
    component: Supplier,
    type: "service"
  },
  // {
  //   path: "/verhuizing",
  //   name: "Moving",
  //   component: Moving,
  //   type: "moving"
  // },
  {
    path: "/voorwerpen",
    name: "Objects",
    component: Objects,
    type: "service"
  },
  {
    path: "/datums",
    name: "Dates",
    component: Dates,
    type: "both"
  },
  {
    path: "/gegevens",
    name: "PersonalData",
    component: PersonalData,
    type: "both"
  },
  {
    path: "/service",
    name: "Service",
    component: Service,
    type: "both"
  },
  // {
  //   path: "/bescherming",
  //   name: "Protection",
  //   component: Protection,
  //   type: "moving"
  // },
  {
    path: "/voorwaarden",
    name: "Terms",
    component: Terms,
    type: "both"
  }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

export default router;
